// src/filters/index.js
import { formatAvatar } from "./avatar"; // 导入头像过滤器
// 注册所有过滤器到 Vue
export const registerFilters = (Vue) => {
  Vue.filter("avatar", formatAvatar);
};
